import { useState } from "react";
import { Menu, X } from "lucide-react";
import { useLanguage } from "@/i18n";
import { scrollToId } from "@/components/Reveal";

const LANGS = ["it", "en", "es", "ja"];

export const Header = () => {
    const { lang, setLang, t } = useLanguage();
    const [open, setOpen] = useState(false);

    const links = [
        { id: "chi-siamo", label: t("nav.about"), testid: "nav-link-about" },
        { id: "prodotti", label: t("nav.products"), testid: "nav-link-products" },
        { id: "perche-noi", label: t("nav.why"), testid: "nav-link-why" },
        { id: "contatti", label: t("nav.contacts"), testid: "nav-link-contacts" },
    ];

    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    return (
        <header data-testid="site-header" className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[#1C2029]/75 backdrop-blur-xl">
            <div className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-3 md:px-12 lg:px-24">
                <button data-testid="header-logo" onClick={() => go("hero")} className="shrink-0" aria-label="Midora home">
                    <img src="/assets/logo-white.png" alt="Midora Atelier Gastronomico" className="h-16 w-auto md:h-20" />
                </button>

                <nav className="hidden items-center gap-8 lg:flex">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={l.testid}
                            onClick={() => go(l.id)}
                            className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/50 transition-colors duration-300 hover:text-white"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>

                <div className="flex items-center gap-4 md:gap-6">
                    <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.2em]">
                        {LANGS.map((l) => (
                            <button
                                key={l}
                                data-testid={`lang-btn-${l}`}
                                onClick={() => setLang(l)}
                                className={`uppercase transition-colors duration-300 ${lang === l ? "text-midora-red" : "text-white/40 hover:text-white"}`}
                            >
                                {l === "ja" ? "jp" : l}
                            </button>
                        ))}
                    </div>
                    <button
                        data-testid="header-cta-listino"
                        onClick={() => go("contatti")}
                        className="hidden bg-[#DBD1BD] px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-[#1C2029] transition-colors duration-300 hover:bg-midora-red hover:text-white md:block"
                    >
                        {t("nav.cta")}
                    </button>
                    <button
                        data-testid="mobile-menu-button"
                        onClick={() => setOpen(!open)}
                        className="text-white lg:hidden"
                        aria-label="Menu"
                    >
                        {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                </div>
            </div>

            {open && (
                <div data-testid="mobile-menu" className="border-t border-white/10 bg-[#1C2029]/95 backdrop-blur-xl lg:hidden">
                    <div className="flex flex-col px-6 py-6">
                        {links.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`mobile-${l.testid}`}
                                onClick={() => go(l.id)}
                                className="border-b border-white/5 py-4 text-left font-display text-2xl text-white/80 transition-colors duration-300 hover:text-white"
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            data-testid="mobile-cta-listino"
                            onClick={() => go("contatti")}
                            className="mt-6 bg-midora-red px-5 py-3 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-white"
                        >
                            {t("nav.cta")}
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
};
